var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "80px",
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Node.js",
    transform: "translate(-17.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(17.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60,16 L60,73 C60,75.209139 61.790861,77 64,77 L153,77 C155.209139,77 157,75.209139 157,73 L157,16 L183,16 C186.865993,16 190,19.581722 190,24 C190,28.418278 186.865993,32 183,32 L205,32 C208.865993,32 212,35.581722 212,40 C212,44.418278 208.865993,48 205,48 L186,48 C182.134007,48 179,51.581722 179,56 C179,60.418278 182.134007,64 186,64 L192,64 C195.865993,64 199,67.581722 199,72 C199,76.418278 195.865993,80 192,80 L140,80 C139.485125,80 138.983234,79.9364709 138.5,79.8158974 C138.016766,79.9364709 137.514875,80 137,80 L46,80 C42.1340068,80 39,76.418278 39,72 C39,67.581722 42.1340068,64 46,64 L7,64 C3.13400675,64 0,60.418278 0,56 C0,51.581722 3.13400675,48 7,48 L47,48 C50.8659932,48 54,44.418278 54,40 C54,35.581722 50.8659932,32 47,32 L22,32 C18.1340068,32 15,28.418278 15,24 C15,19.581722 18.1340068,16 22,16 L60,16 Z M60,15.6687101 C57.1085111,14.6852253 55,11.6240236 55,8 C55,3.581722 58.1340068,0 62,0 L119,0 C122.865993,0 126,3.581722 126,8 C126,8.69059914 125.923432,9.36076016 125.779469,10 L64,10 C61.790861,10 60,11.790861 60,14 L60,15.6687101 Z",
    id: "Combined-Shape",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#7F7F7F",
    cx: 209,
    cy: 72,
    rx: 7,
    ry: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    x: 61.25,
    y: 11.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.440069,29.375 L100,29.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(124.000000, 29.000000) scale(1, -1) translate(-124.000000, -29.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.279965,34.375 L100,34.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(113.000000, 34.000000) scale(1, -1) translate(-113.000000, -34.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.360017,43.5 L100,43.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(121.500000, 43.000000) scale(1, -1) translate(-121.500000, -43.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.360017,48.5 L100,48.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(121.500000, 48.000000) scale(1, -1) translate(-121.500000, -48.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.360017,53.5 L100,53.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(121.500000, 53.000000) scale(1, -1) translate(-121.500000, -53.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.319991,58.375 L100,58.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(115.000000, 58.000000) scale(1, -1) translate(-115.000000, -58.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.319991,63.375 L100,63.375",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(115.000000, 63.000000) scale(1, -1) translate(-115.000000, -63.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,36.5 L86,36.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 36.500000) scale(1, -1) translate(-86.670002, -36.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,32.5 L86,32.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 32.500000) scale(1, -1) translate(-86.670002, -32.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,28.5 L86,28.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 28.500000) scale(1, -1) translate(-86.670002, -28.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,48.5 L86,48.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 48.500000) scale(1, -1) translate(-86.670002, -48.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,44.5 L86,44.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 44.500000) scale(1, -1) translate(-86.670002, -44.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3400043,40.5 L86,40.5",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(86.670002, 40.500000) scale(1, -1) translate(-86.670002, -40.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,75.625 L92,21.625",
    id: "Line-6",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(92.000000, 48.312500) scale(1, -1) translate(-92.000000, -48.312500) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.82784,20 L78.118659,20 L151.289772,20 L145.82784,20 L78.118659,20 L154.02323,20 L145.82784,20 Z M73.118659,20 L62,20 L73.118659,20 Z",
    id: "lines",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsEmptyState);
export default __webpack_public_path__ + "static/media/nodejs-empty-state.afba440a723c5e996d091f68b0d2ca21.svg";
export { ForwardRef as ReactComponent };